import { AgreementSigningMethod } from "./Agreement";
import Bundle from "./Bundle";
import CreditCheckResult from "./CreditCheckResult";
import Product from "./Product";

export class AgreementMetadata {
  /**
   * Name of signee used in case of automatic signing.
   */
  readonly signee?: string;
  readonly status?: AgreementStatus;
  readonly creditCheckResult?: CreditCheckResult;
  readonly subscriptions?: Product[];
  readonly bundles?: Bundle[];
  readonly signingMethod?: AgreementSigningMethod;
  readonly visits?: AgreementVisit[];
  readonly createdAt?: Date;
  readonly orderId?: string;
  readonly orderSerialId?: string;
  readonly signedAt?: Date;

  constructor(deriveFrom?: Partial<AgreementMetadata>) {
    if (!deriveFrom) {
      return;
    }

    if (!(deriveFrom instanceof AgreementMetadata)) {
      //  Remove getters whom Object.assign does not like.
      delete (deriveFrom as any).isManualSignatureRequired;
    }

    Object.assign(this, deriveFrom);

    if (this.visits) {
      this.visits = this.visits.map(visit => new AgreementVisit(visit));
    }

    if (this.createdAt) {
      this.createdAt = new Date(this.createdAt);
    }

    if (this.signedAt) {
      this.signedAt = new Date(this.signedAt);
    }

    if (this.bundles) {
      this.bundles = this.bundles.map(bundle => new Bundle(bundle));
    }

    if (this.creditCheckResult) {
      this.creditCheckResult = new CreditCheckResult(this.creditCheckResult);
    }
  }

  get isManualSignatureRequired() {
    return [AgreementSigningMethod.Manual, AgreementSigningMethod.Sms].includes(this.signingMethod);
  }

  get isSigned() {
    return this.status === AgreementStatus.Signed;
  }

  get isCanceled() {
    return [AgreementStatus.Canceled, AgreementStatus.Revised].includes(this.status);
  }

  get isOpened() {
    return [AgreementStatus.Signed, AgreementStatus.Opened].includes(this.status);
  }


  get containsEnergySubscription() {
    return this.subscriptions.length > 0;
  }
}

export enum AgreementStatus {
  Sent = 'sent',
  Signed = 'signed',
  Opened = 'opened',
  Canceled = 'canceled',
  Revised = 'revised',
  Declined = 'declined'
}

export class AgreementVisit {
  readonly id: string;
  readonly date: Date;

  constructor(deriveFrom?: Partial<AgreementVisit>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }

    if (this.date) {
      this.date = new Date(this.date);
    }
  }
}